import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';

const CustomRadio = ({ value, onChange, options = [], size = 'medium', disabled = false, style = {} }) => {
  // 기본 스타일
  const defaultStyle = {
    formcontrol: {
      display: 'flex',
      alignItems: 'center',
      columnGap: '12px',
      '& .MuiRadio-root': {
        marginRight: 0,
      },
      ...style.formcontrol,
    },
    radio: { padding: 0.5, marginTop: '-1px', color: '#ddd', '&.Mui-checked': { color: '#0C8CE9' }, ...style.radio },
    label: { margin: 0, '& .MuiFormControlLabel-label': { fontSize: '14px', color: '#767676' }, ...style.label },
  };

  return (
    <FormControl>
      <RadioGroup row value={value} onChange={onChange} sx={defaultStyle.formcontrol}>
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio size={size} disabled={disabled} sx={defaultStyle.radio} />}
            label={option.label}
            sx={defaultStyle.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default CustomRadio;
